// Returns true when the backend rejected a request because no bearer token
// was sent — an expected state for guests, not a user-facing error.
export const isMissingAuthTokenError = (message: unknown): boolean =>
  typeof message === "string" && /no authorization token/i.test(message);

// Normalizes an axios error into a displayable message. Missing-token errors
// return "" (falsy) so error states stay empty and callers' `err || fallback`
// expressions fall back to a friendly message instead of raw backend text.
export const apiErrorMessage = (error: any, fallback: string): string => {
  const message = error?.response?.data?.message;
  return isMissingAuthTokenError(message) ? "" : message || fallback;
};
